export enum HolidayCategory {
  FREE_DAY,
  VACATION,
  FREE_DAY_ON_DEMAND,
  CHILD_CARE_VACATION,
  SPECIAL_CIRCUMSTANCES,
  ILLNESS
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/holiday/holiday-category.enum.ts